"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pseudolocalise = void 0;
const DEBUG_CHARS = {
    "a": "á",
    "b": "β",
    "c": "ç",
    "d": "δ",
    "e": "è",
    "f": "ƒ",
    "g": "ϱ",
    "h": "λ",
    "i": "ï",
    "j": "J",
    "k": "ƙ",
    "l": "ℓ",
    "m": "₥",
    "n": "ñ",
    "o": "ô",
    "p": "ƥ",
    "q": "9",
    "r": "ř",
    "s": "ƨ",
    "t": "ƭ",
    "u": "ú",
    "v": "Ʋ",
    "w": "ω",
    "x": "ж",
    "y": "¥",
    "z": "ƺ",
    "A": "Â",
    "B": "ß",
    "C": "Ç",
    "D": "Ð",
    "E": "É",
    "F": "F",
    "G": "G",
    "H": "H",
    "I": "Ì",
    "J": "J",
    "K": "K",
    "L": "£",
    "M": "M",
    "N": "N",
    "O": "Ó",
    "P": "Þ",
    "Q": "Q",
    "R": "R",
    "S": "§",
    "T": "T",
    "U": "Û",
    "V": "V",
    "W": "W",
    "X": "X",
    "Y": "Ý",
    "Z": "Z",
    "0": "⓪",
    "1": "①",
    "2": "②",
    "3": "③",
    "4": "④",
    "5": "⑤",
    "6": "⑥",
    "7": "⑦",
    "8": "⑧",
    "9": "⑨",
};
const PADDING_PERCENT = 0.25;
const INTERPOLATION_RE = /(?:\{\{.*?\}\}|<\/?.*?>)/gmu;
const replaceChars = (str) => Array.from(str)
    .map((char) => DEBUG_CHARS[char] ?? char)
    .join("");
// This is 445 characters of lorem ipsum, which will handle strings up to 1,480
// characters long. At that point, we're probably not worried about additional
// length breaking the UI.
const LIPSUM = replaceChars("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.");
/**
 * Generate a pseudolocalised version of `str` for debug purposes.
 *
 * Ignores i18next variables.
 *
 * @example
 *
 * ```typescript
 * pseudolocalize("Good Morning, {{name}}!");
 * // "Gôôδ Môřñïñϱ, {{name}}!"
 * ```
 *
 * @public
 */
const pseudolocalise = (str, padLength = false) => {
    const constantParts = str.split(INTERPOLATION_RE);
    const variableParts = str.match(INTERPOLATION_RE) ?? [];
    const paddingLength = padLength ? Math.ceil(constantParts.join("").length * PADDING_PERCENT) : 0;
    const pseudolocalisedStr = constantParts
        .map(replaceChars)
        .flatMap((stringPart, i) => (i < variableParts.length ? [stringPart, variableParts[i]] : stringPart))
        .join("");
    const pseudolocalizedPadding = LIPSUM.slice(0, paddingLength);
    return `${pseudolocalisedStr}${pseudolocalizedPadding}`;
};
exports.pseudolocalise = pseudolocalise;
//# sourceMappingURL=data:application/json;base64,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